// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"G4-z","colorTextValue":"H4-z","swatches":"I4-z","collapseLink":"J4-z","isCollapsed":"K4-z","dropdown":"L4-z","disabled":"M4-z"};